export default function ContentFifth({ verticalTabsState }) {
  return (
    <div
      className={`content-5 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 5
          ? "max-h-[1000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h1 className="font-mont text-[36px] leading-[40px] my-[0.67em]">
        <strong>Maximize Your</strong>
        <strong> Warehouse Efficiency</strong>
      </h1>

      <p className="text-[16px] mb-[25px] leading-[28px]">
        Modern online warehouse management software.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Improve Performance </strong>
        <strong>& Process Time</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Better organize your warehouse with the smart double entry inventory
        system.
      </p>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Get the most efficient stocking method and improve all your internal
        operations.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Less Stock, No Stockouts</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        with fully automated replenishment.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Experience Total Traceability</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Track every stock move with Mean3's unique double-entry inventory
        system.
      </p>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Track every stock move from purchase to warehouse bin to sales order.
        Trace lots or serials upstream or downstream from anywhere in your
        supply chain.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Clear And Complete Reporting</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Stay in the know with real-time reports.
      </p>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Make smarter decisions with real-time dynamic reports that you can save
        and share with anybody. Keep key information at your fingertips with
        custom dashboards.
      </p>
    </div>
  );
}
